<template>
	<div
		id="horizontal-hero"
		:style="{ background: transparentBackground ? 'none' : '' }"></div>
</template>

<script>
export default { props: ["transparentBackground"] };
</script>

<style scoped>
div#horizontal-hero {
	background-image: url("https://cdn.pixabay.com/photo/2017/12/09/08/18/pizza-3007395_1280.jpg");
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	height: 100px;
	border-top-left-radius: var(--section-border-radius);
	border-top-right-radius: var(--section-border-radius);
}
</style>
